var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"botaoLogar",attrs:{"color":"transparent","tile":"","elevation":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.loginKeycloak.apply(null, arguments)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-login")]),_vm._v(" Entrar ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }